<div class="builder-history">
  <app-search-input
    [value]="searchQuery"
    (inputChanged)="onSearchChange($event)"
  ></app-search-input>
  <div class="history-list">
    @for (item of filteredPaginatedRecords; track item) {
      <div class="query-item">
        <div class="query-content">
          <!-- scanner-disable-next-line R6 -- native-element-driven read-only viewer (WAP-1568) -->
          <textarea
            #txt
            [rows]="getLineCount(item.query) > 6 ? 6 : getLineCount(item.query)"
            [value]="item.query"
            readonly
            [style.height.px]="item.expanded ? txt.scrollHeight : null"
          ></textarea>
          @if (getLineCount(item.query) > 6) {
            <div class="show-more-panel">
              <sui-button variant="ghost" (click)="toggleItemExpand(item)">
                {{
                  item.expanded
                    ? ("query-history-viewer.label.show-less" | translate)
                    : ("query-history-viewer.label.show-more" | translate)
                }}
              </sui-button>
            </div>
          }
        </div>
        <div class="query-footer">
          <span>
            {{ "search-builder.button.saved-on" | translate }}
            <span class="bold">
              {{ item.saved_at * 1000 | date: "yyyy-MM-dd HH:mm:ss" }}
            </span>
            {{ "search-builder.button.saved-by" | translate }}
            <span class="bold">{{ item.saved_by }}</span>
          </span>
          <sui-button
            variant="primary"
            [leadingIcon]="['fas', 'upload']"
            (click)="historyRecordClick(item)"
          >
            {{ "search-builder.button.load" | translate }}
          </sui-button>
        </div>
      </div>
    }
  </div>

  <div class="pagination-holder">
    <sui-pagination
      [collectionSize]="totalRecords"
      [currentPage]="currentPage"
      [pageSize]="5"
      (pageChanged)="onPageChange($event)"
      (doPageChange)="onPageChange($event)"
    ></sui-pagination>
  </div>
</div>
